<template>
  <div class="w-100 h-100">
    <LineChart
      :is-loading="isLoading"
      :chart-data="chartData"
      :title="title"
      :colors="colors"
      :height="height"
      :width="width"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Job Views Statistics - 30 days',
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '400',
    },
  },
  data() {
    return {
      isLoading: false,
      title: 'Job Views Statistics - 30 days',
      chartData: {},
      colors: [
        this.$themeColors.primary,
        this.$themeColors.dark,
      ],
    }
  },
  created() {
    this.initComponent()
  },
  methods: {
    initComponent() {
      const reportId = this.$route.params.report_name.split('__')[1]

      this.isLoading = true
      this.$http
        .post(`/api/event-reports/analytics`, {
          form_data: {
            fetch_data: ['job_visit'],
            report_id: reportId,
          }
        })
        .then(response => {
          const { reports } = response.data

          this.chartData = {
            'Job Visit': reports['job_visit'],
          }

          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    }
  },
}
</script>

<style>

</style>